import { LandingHeader } from './LandingHeader'
import { LandingMain } from './LandingMain'
import classes from './LandingPage.module.css'

export const LandingPage = () => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.root}>
        <LandingHeader />
        <LandingMain />
      </div>
      <footer className={classes.footer}>© 2025 Crossian LLC. All rights reserved.</footer>
    </div>
  )
}
